export enum FeedbackPages {
  STEP1 = 'step-1',
  FEEDBACK_FORM = 'feedback-form',
  CONFIRMATION_PAGE = 'confirmation-page',
  PAID_USER_FEEDBACK = 'paid-user-feedback',
  ACCOUNT_DELETION_IN_PROGRESS = 'account-deletion-in-progress'
}
